'use client'

import { useSelector } from "react-redux"
import Image from "../../images/Image"
import { RootState } from "../../../store"
import { useTransform } from "framer-motion"
import useTranslation from "../../CustomHooks/useTranslation"
import { inputFieldContent } from "../../inputfields/InputFieldContent"
import ToolTip from "../../ToolTip/ToolTip"

// import { Check } from 'lucide-react'
// import { Button } from "@/components/ui/button"

interface Step {
  id: number
  name: string
  status: 'complete' | 'current' | 'upcoming'
}

interface ProgressStepperProps {
  currentStep: number
  setCurrentStep: (step: number) => void
  currentSavedStep: number
  type?: string
  id?: string
  selectedOption?: string
}

export function ProgressStepper({ currentStep, setCurrentStep, currentSavedStep, type, id, selectedOption }: ProgressStepperProps) {
  const { savedData } = useSelector((state: RootState) => state.addMD)
  const { translate } = useTranslation(inputFieldContent)
  const steps: Step[] = [
    { id: 1, name: 'Basic Details', status: currentStep > 1 ? 'complete' : currentStep === 1 ? 'current' : 'upcoming' },
    { id: 2, name: 'Identification Details', status: currentStep > 2 ? 'complete' : currentStep === 2 ? 'current' : 'upcoming' },
    { id: 3, name: 'Bank Details', status: currentStep > 3 ? 'complete' : currentStep === 3 ? 'current' : 'upcoming' },
    { id: 4, name: 'Business Details', status: currentStep > 4 ? 'complete' : currentStep === 4 ? 'current' : 'upcoming' },
    { id: 5, name: 'Photo', status: currentStep > 5 ? 'complete' : currentStep === 5 ? 'current' : 'upcoming' },
    { id: 6, name: 'Service Fee', status: currentStep > 6 ? 'complete' : currentStep === 6 ? 'current' : 'upcoming' },
  ] as const

  const customerSteps: Step[] = [
    {
      id: 1,
      name: "Basic Details",
      status:
        currentStep > 1
          ? "complete"
          : currentStep === 1
          ? "current"
          : ("upcoming" as const),
    },
    {
      id: 2,
      name: "Identification Details",
      status:
        currentStep > 2
          ? "complete"
          : currentStep === 2
          ? "current"
          : ("upcoming" as const),
    },
    {
      id: 3,
      name: "Bank Details",
      status:
        currentStep > 3
          ? "complete"
          : currentStep === 3
          ? "current"
          : ("upcoming" as const),
    },
    {
      id: 5,
      name: "Photo",
      status:
        currentStep > 5
          ? "complete"
          : currentStep === 5
          ? "current"
          : ("upcoming" as const),
    },
    ...(selectedOption === "Corporate"
      ? [
          {
            id: 6,
            name: "Corporate Details",
            status: (currentStep > 6
              ? "complete"
              : currentStep === 6
              ? "current"
              : "upcoming") as "complete" | "current" | "upcoming",
          },
        ]
      : []),
  ];

  return (
    <div className="mb-6">
      <ol role="list" className="flex items-center">
        {(type !== 'Customers' ? steps : customerSteps).map((step, stepIdx) => (
          <li key={step.name} className="relative flex-1">
            <div className="flex flex-col items-center">
              <div className="flex items-center z-10">
                <span
                  className={`h-6 w-6 rounded-full flex items-center justify-center ${Object.keys(savedData).includes(step.name.toLowerCase()) ? 'bg-positive_light' : 'bg-p_light'
                    }`}
                >
                  {Object.keys(savedData).includes(step.name.toLowerCase()) ? (
                    (
                      Object.keys(savedData).includes(step.name.toLowerCase()) && step.status === 'current' ?
                        <span
                          className={`h-3 w-3 rounded-full bg-positive
                            }`}
                        />

                        : <Image src="right_mark" />
                    )
                  ) : (
                    <span
                      className={`h-3 w-3 rounded-full ${(step.status === 'current' || step.status === 'complete') ? 'bg-p_primary' : 'bg-p_light'
                        }`}
                    />
                  )}
                </span>
              </div>
              <span
                className={`mt-2 cursor-pointer group truncate text-sm font-medium flex justify-evenly items-center ${step.status === 'current'
                  ? 'text-p_primary'
                  : step.status === 'upcoming'
                    ? 'text-gray-500'
                    : 'text-gray-600'
                  }`}
                onClick={() => {
                  if ((id && (step.id === 6 || step.id === 5) && Object.keys(savedData).includes('photo')) || currentSavedStep + 1 >= step.id) {
                    setCurrentStep(step.id);
                  }
                }}
                data-testid={step.name}
              >
                {translate(step.name)}
                <ToolTip ToolTipItem={translate(step.name)} left={'mx-auto'} top="top-2 z-[999]" />
              </span>
            </div>
            {stepIdx !== (type !== 'Customers' ? steps.length - 1 : customerSteps.length - 1) && (
              <div
                className={`absolute top-3 left-1/2 h-0.5 w-full ${Object.keys(savedData).includes(step.name.toLowerCase()) ? 'bg-positive' : 'bg-gray-200'
                  }`}
              />
            )}
          </li>
        ))}
      </ol>
    </div>
  )
}